<template>
  <div class="customer-info">
    <Spin v-if="loading"></Spin>
    <div v-else-if="customerInstance">
      <div style="font-weight: bold; font-size: 120%; margin-bottom: 15px;">
        <router-link :to="{ name: 'menu.account.edit_account', params: { accountId: customerId } }" target="_blank">{{ customerInstance.name }}</router-link>
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.edit.account_number') }}: </span>
        {{ customerInstance.account_number }}
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.edit.short_code')}}: </span>
        {{ customerInstance.short_code }}
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.edit.country') }}: </span>
        {{ customerInstance.country_code }}
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.edit.preferred_currency') }}: </span>
        {{ customerInstance.preferred_currency }}
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.attribution') }}: </span>
        {{ customerInstance.attribution ? $t(`org.${customerInstance.attribution}`) : '' }}
      </div>
      <div>
        <span style="font-weight: bold">{{ $t('account.edit.category') }}: </span>
        {{ customerInstance.category }}
      </div>
    </div>
    <p v-else>{{ $t('empty_data') }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "CustomerInfoSimpleBox",
  props: {
    customerId: { type: Number, required: true }
  },
  data () {
    return {
      loading: false,
      customerInstance: null
    }
  },
  mounted () {
    this.getCustomerInfo()
  },
  methods: {
    ...mapActions(['getAccount']),
    getCustomerInfo () {
      this.loading = true
      this.getAccount(this.customerId)
        .then(data => {
          this.customerInstance = data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    customerId (val) {
      this.getCustomerInfo(val)
    }
  }
}
</script>
